<alaris-menu-sidebar
	[menuList]="menuList()"
	[showLogo]="config.env.showLogo ?? true"
	[showTitle]="config.env.showTitle ?? true"
>
</alaris-menu-sidebar>

<alaris-root-content [fade]="getOverflow() || false">
	<alaris-card class="app-card">
		<div class="alaris-top-content">
			<ds-breadcrumbs class="breadcrumbs" [items]="breadcrumbs()" />
			<alaris-navbar
				[backRoutePath]="getBackRoutePath()"
				[backRoute]="getBackRoute()"
				[title]="getTitle() || dynamicTitle | translate">
				@if (!globals) {
					<alaris-profile class="profile" (logOutAttempt)="auth.logOut()"></alaris-profile>
				}
			</alaris-navbar>
		</div>

		<div [@mainLayoutChanged]="prepareInterfaceRoute(outlet)" [class.overflow]="getOverflow()" class="alaris-content">
			<router-outlet #outlet="outlet"></router-outlet>
		</div>
	</alaris-card>
</alaris-root-content>
